import request from '@/utils/request'

const pre = "/products/type";

export const reqListProductsType = (data) => {
    return request({
        url: pre + '/list', method: 'post', data
    })
}

export const reqInsertProductsType = (data) => {
    return request({
        url: pre + '/insert', method: 'post', data
    })
}
export const reqUpdateProductsType = (data) => {
    return request({
        url: pre + '/update', method: 'post', data
    })
}
export const reqDeleteProductsType = (params) => {
    return request({
        url: pre + '/delete', method: 'get', params
    })
}
export const reqGetProductsTypeById = (params) => {
    return request({
        url: pre + '/detail', method: 'get', params
    })
}
export const reqListAllProductsType = (params) => {
    return request({
        url: pre + '/listAll', method: 'get', params
    })
}
export const reqAssertLayoutProductsType = (params) => {
    return request({
        url: pre + '/assertLayout', method: 'get', params
    })
}
